// extracted by mini-css-extract-plugin
export var closeButton = "_1l-3";
export var header = "_1l-0";
export var link = "_1l-1";
export var retryButton = "_1l-2";